import { createSlice } from "@reduxjs/toolkit";

const localCommunityTrainerRoleSlice = createSlice({
  name: "localCommunityTrainerRoles",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    fetchLocalCommunityTrainerRolesRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchLocalCommunityTrainerRolesSuccess: (state, action) => {
      state.loading = false;
      state.items = action.payload;
    },
    fetchLocalCommunityTrainerRolesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchLocalCommunityTrainerRolesRequest,
  fetchLocalCommunityTrainerRolesSuccess,
  fetchLocalCommunityTrainerRolesFailure,
} = localCommunityTrainerRoleSlice.actions;

export default localCommunityTrainerRoleSlice.reducer;